Unit MainSitePage;

Interface

Uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls,
  WEBLib.Toast,
  Web.Core.Consts,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.WebCtrls,
  WEBLib.Lists,
  MainForm.Base,
  App.Web.Consts,
  App.Enumerations,
  WEBLib.ExtCtrls;

Type
  TMainSiteForm = Class(TMainBaseForm)
    SchoolsLink: TLabel;
    AcademiesLink: TLabel;
    DashboardLink: TLabel;
    CostingsLink: TLabel;
    InvoicesLink: TLabel;
    ActionsLink: TLabel;
    UserNameLabel: TLabel;
    UserScopeLabel: TLabel;
    EventViewerLink: TLabel;
    RemittancesLink: TLabel;
    AppVersionLabel: TLabel;
    CommunicationsLink: TLabel;
    LogoutLink: TLabel;
    procedure SchoolsLinkClick(Sender: TObject);
    Procedure WebFormBeforeUnload(Sender: TObject; Var AMessage: String);
    procedure AcademiesLinkClick(Sender: TObject);
    procedure DashboardLinkClick(Sender: TObject);
    procedure CostingsLinkClick(Sender: TObject);
    procedure InvoicesLinkClick(Sender: TObject);
    procedure ActionsLinkClick(Sender: TObject);
    procedure EventViewerLinkClick(Sender: TObject);
    procedure RemittancesLinkClick(Sender: TObject);
    procedure CommunicationsLinkClick(Sender: TObject);
    procedure LogoutLinkClick(Sender: TObject);
  Private
    { Private declarations }
    FDisplayedPage: TAppPage;
    FWaitDirection: TNavDirection;
    [async]
    Procedure ShowForm(AFormClass: TFormClass; Const ADisplayedPage: TAppPage; Const ANavDirection: TNavDirection;
      AProc: TFormCreatedProc = Nil; AlwaysClose: Boolean = false); async; Reintroduce;
    Procedure MainPageUpdate(Sender: TObject);
    Procedure ChangeThePage(Const ANewPage: TAppPage; Const ANavDirection: TNavDirection);
    procedure SetLabels;
  Protected
    [async]
    Procedure InitForm; async; Override;
    Procedure HashChange(Sender: TObject; AHash: String; Var Handled: Boolean);
    Procedure HandlePopState(State: TJSObject; Const AURL, AHash: String); Override;
    function GetDebugInfo: String; override;
  Public

    { Public declarations }
    Class Procedure DisplayPage(Const AElementId: String); Override;
    Procedure CloseMainPage; Override;
  protected procedure LoadDFMValues; override; End;

Var
  MainSiteForm: TMainSiteForm;

Implementation

{$R *.dfm}

Uses
  Rtti,
  WebForm.Core,
  BaseSitePage,
  MainDataModule,
  ErrorPage,
  App.ReturnTypes,
  DashboardPage,
  SchoolListPage,
  AcademyListPage,
  CostingListPage,
  InvoiceListPage,
  ActionsPage,
  EventViewerListPage,
  RemittancesListPage,
  App.Version,
  CommunicationsListPage;

Procedure TMainSiteForm.WebFormBeforeUnload(Sender: TObject; Var AMessage: String);
Begin
  Inherited;
  CloseDisplayedForm(True);
End;

Procedure TMainSiteForm.MainPageUpdate(Sender: TObject);
Begin

  If Not Assigned(MainSiteForm) Then
    Exit;

End;

procedure TMainSiteForm.RemittancesLinkClick(Sender: TObject);
begin
  inherited;
  ChangeThePage(TAppPage.apRemittances, TNavDirection.ndNone);

end;

procedure TMainSiteForm.AcademiesLinkClick(Sender: TObject);
begin
  inherited;
  ChangeThePage(TAppPage.apAcademy, TNavDirection.ndNone);

end;

procedure TMainSiteForm.ChangeThePage(Const ANewPage: TAppPage; Const
    ANavDirection: TNavDirection);
begin
{$IFNDEF RELEASE}
  UpdateDebugInfo;
{$ENDIF}

  Case ANewPage Of
    apNoChange:
      ;

    apDashboard:
      ShowForm(TDashboardForm, TAppPage.apDashboard, ANavDirection, nil, True);

    apSchools:
      ShowForm(TSchoolsForm, TAppPage.apSchools, ANavDirection, nil, True);

    apAcademy:
      ShowForm(TAcademyForm, TAppPage.apAcademy, ANavDirection, nil, True);

    apCosting:
      ShowForm(TCostingListForm, TAppPage.apCosting, ANavDirection, nil, True);

    apInvoices:
      ShowForm(TInvoiceListForm, TAppPage.apInvoices, ANavDirection, nil, True);

    apActions:
      ShowForm(TActionsForm, TAppPage.apActions, ANavDirection, nil, True);

    apEventViewer:
      ShowForm(TEventViewerListForm, TAppPage.apEventViewer, ANavDirection, nil, True);

    apRemittances:
      ShowForm(TRemittanceListForm, TAppPage.apRemittances, ANavDirection, nil, True);

    apCommunications:
      ShowForm(TCommunicationsListForm, TAppPage.apCommunications, ANavDirection, nil, True);

  end;

end;

Procedure TMainSiteForm.CloseMainPage;
Begin
  Inherited;

End;

procedure TMainSiteForm.CommunicationsLinkClick(Sender: TObject);
begin
  inherited;
  ChangeThePage(TAppPage.apCommunications, TNavDirection.ndNone);

end;

procedure TMainSiteForm.CostingsLinkClick(Sender: TObject);
begin
  inherited;
  ChangeThePage(TAppPage.apCosting, TNavDirection.ndNone);

end;

procedure TMainSiteForm.DashboardLinkClick(Sender: TObject);
begin
  inherited;
  ChangeThePage(TAppPage.apDashboard, TNavDirection.ndNone);

end;

Class Procedure TMainSiteForm.DisplayPage(Const AElementId: String);

  Procedure AfterCreate(AForm: TObject);
  Begin
    // TMainPage(AForm).SetLabels;
  End;

Begin
  If Not Assigned(MainSiteForm) Then
  Begin
    MainSiteForm := TMainSiteForm.CreateNew(AElementId, @AfterCreate);
  End;
End;

procedure TMainSiteForm.EventViewerLinkClick(Sender: TObject);
begin
  inherited;
  ChangeThePage(TAppPage.apEventViewer, TNavDirection.ndNone);

end;

Procedure TMainSiteForm.HandlePopState(State: TJSObject; Const AURL, AHash: String);
Var
  AGadgetPage: TAppPage;
  lHash: String;
Begin
  If Not Assigned(FDisplayedForm) Then
    Exit;

  If Not (FDisplayedForm Is TBaseSiteForm) Then
    Exit;

  If TBaseSiteForm(FDisplayedForm).PageHash = AHash Then
    Exit;
End;

Procedure TMainSiteForm.HashChange(Sender: TObject; AHash: String; Var Handled: Boolean);
Var
  APage: TAppPage;
  lHash: String;
Begin
End;

Procedure TMainSiteForm.InitForm;
Begin
  Inherited;
  MainData.ErrorMessageProc := ErrorHandler;
  Caption := Application_Title;
  // Application.OnHashChange := HashChange;

  ShowWaitMessage;

  { TODO : This will depend on the link? }
  ChangeThePage(TAppPage.apDashboard, TNavDirection.ndNone);

  SetLabels;
End;

procedure TMainSiteForm.SetLabels;
begin
  UserNameLabel.Caption := MainData.UserProfile.UserName;
  UserScopeLabel.Caption := MainData.UserProfile.Scope;

  AppVersionLabel.Caption := 'v' + AppVersion.VersionString;

end;

procedure TMainSiteForm.InvoicesLinkClick(Sender: TObject);
begin
  inherited;
  ChangeThePage(TAppPage.apInvoices, TNavDirection.ndNone);

end;

procedure TMainSiteForm.LogoutLinkClick(Sender: TObject);
begin
  inherited;

  // Ensure any hosted page is closed before auth redirect starts.
  CloseDisplayedForm(True);
  MainData.LogoutUser(True);

end;

procedure TMainSiteForm.ShowForm(AFormClass: TFormClass; Const
    ADisplayedPage: TAppPage; Const ANavDirection: TNavDirection; AProc:
    TFormCreatedProc = Nil; AlwaysClose: Boolean = false);

{ The Process is
  Form Created
  AForm.WebFormCreate;
  AForm.DisplayingAs
  - Set CustomerType (Primary, Secondary)
  AForm.InitForm
  AForm.LoadBooking
}

[async]
  Procedure AfterFormCreated(AForm: TObject); async;
  Begin

    If AFormClass.InheritsFrom(TCoreWebForm) Then
      TCoreWebForm(AForm).OnSelfClose := OnFormSelfClose;

    If AFormClass.InheritsFrom(TBaseSiteForm) Then
    Begin
      TBaseSiteForm(AForm).NavDirection := ANavDirection;
      TBaseSiteForm(AForm).OnSitePageChange := MainPageUpdate;
      TBaseSiteForm(AForm).DoChangeSitePage := ChangeThePage;
      TBaseSiteForm(AForm).DisplayingAs := ADisplayedPage;
      Await(TBaseSiteForm(AForm).InitForm);
      Await(TBaseSiteForm(AForm).LoadData);
      TBaseSiteForm(AForm).AfterLoaded;
    End
    Else If AFormClass.InheritsFrom(TCoreWebForm) Then
      Await(TBaseSiteForm(AForm).InitForm);

    HideWaitMessage;

    If Assigned(AProc) Then
      AProc(AForm);

  End;

Begin
  // Note that MainPanel is no longer a component. This now just uses a div on the
  // template with that id.
  If Assigned(FDisplayedForm) And (FDisplayedForm.ClassType = AFormClass) And (AlwaysClose = false) Then
    Exit;

  If Not CloseDisplayedForm(True) Then
    Exit;

  FDisplayedPage := ADisplayedPage;

  // hide text from logout link
  LogoutLink.Caption := '';

  Application.CreateForm(AFormClass, 'MainPanel', FDisplayedForm, @AfterFormCreated);

End;

function TMainSiteForm.GetDebugInfo: String;
begin
  Result := MainData.DebugInfo;
end;

procedure TMainSiteForm.SchoolsLinkClick(Sender: TObject);
begin
  ChangeThePage(TAppPage.apSchools, TNavDirection.ndNone);
end;

procedure TMainSiteForm.ActionsLinkClick(Sender: TObject);
begin
  inherited;
  ChangeThePage(TAppPage.apActions, TNavDirection.ndNone);

end;

procedure TMainSiteForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  SchoolsLink := TLabel.Create('SchoolsLink');
  AcademiesLink := TLabel.Create('AcademiesLink');
  DashboardLink := TLabel.Create('DashboardLink');
  CostingsLink := TLabel.Create('CostingsLink');
  InvoicesLink := TLabel.Create('InvoicesLink');
  ActionsLink := TLabel.Create('ActionsLink');
  UserNameLabel := TLabel.Create('UserNameLabel');
  UserScopeLabel := TLabel.Create('UserScopeLabel');
  EventViewerLink := TLabel.Create('EventViewerLink');
  RemittancesLink := TLabel.Create('RemittancesLink');
  AppVersionLabel := TLabel.Create('app-version');
  CommunicationsLink := TLabel.Create('communications-link');
  LogoutLink := TLabel.Create('logout-link');

  SchoolsLink.BeforeLoadDFMValues;
  AcademiesLink.BeforeLoadDFMValues;
  DashboardLink.BeforeLoadDFMValues;
  CostingsLink.BeforeLoadDFMValues;
  InvoicesLink.BeforeLoadDFMValues;
  ActionsLink.BeforeLoadDFMValues;
  UserNameLabel.BeforeLoadDFMValues;
  UserScopeLabel.BeforeLoadDFMValues;
  EventViewerLink.BeforeLoadDFMValues;
  RemittancesLink.BeforeLoadDFMValues;
  AppVersionLabel.BeforeLoadDFMValues;
  CommunicationsLink.BeforeLoadDFMValues;
  LogoutLink.BeforeLoadDFMValues;
  MainToast.BeforeLoadDFMValues;
  try
    Cursor := crHandPoint;
    Caption := 'InvoicesLink';
    SchoolsLink.SetParentComponent(Self);
    SchoolsLink.Name := 'SchoolsLink';
    SchoolsLink.Left := 40;
    SchoolsLink.Top := 192;
    SchoolsLink.Width := 48;
    SchoolsLink.Height := 18;
    SchoolsLink.Caption := 'Schools';
    SchoolsLink.ElementFont := efCSS;
    SchoolsLink.ElementPosition := epIgnore;
    SchoolsLink.HeightStyle := ssAuto;
    SchoolsLink.HeightPercent := 100.000000000000000000;
    SchoolsLink.WidthStyle := ssAuto;
    SchoolsLink.WidthPercent := 100.000000000000000000;
    SetEvent(SchoolsLink, Self, 'OnClick', 'SchoolsLinkClick');
    AcademiesLink.SetParentComponent(Self);
    AcademiesLink.Name := 'AcademiesLink';
    AcademiesLink.Left := 40;
    AcademiesLink.Top := 216;
    AcademiesLink.Width := 70;
    AcademiesLink.Height := 18;
    AcademiesLink.Caption := 'Academies';
    AcademiesLink.ElementFont := efCSS;
    AcademiesLink.ElementPosition := epIgnore;
    AcademiesLink.HeightStyle := ssAuto;
    AcademiesLink.HeightPercent := 100.000000000000000000;
    AcademiesLink.WidthStyle := ssAuto;
    AcademiesLink.WidthPercent := 100.000000000000000000;
    SetEvent(AcademiesLink, Self, 'OnClick', 'AcademiesLinkClick');
    DashboardLink.SetParentComponent(Self);
    DashboardLink.Name := 'DashboardLink';
    DashboardLink.Left := 40;
    DashboardLink.Top := 168;
    DashboardLink.Width := 70;
    DashboardLink.Height := 18;
    DashboardLink.Caption := 'Dashboard';
    DashboardLink.ElementFont := efCSS;
    DashboardLink.ElementPosition := epIgnore;
    DashboardLink.HeightStyle := ssAuto;
    DashboardLink.HeightPercent := 100.000000000000000000;
    DashboardLink.WidthStyle := ssAuto;
    DashboardLink.WidthPercent := 100.000000000000000000;
    SetEvent(DashboardLink, Self, 'OnClick', 'DashboardLinkClick');
    CostingsLink.SetParentComponent(Self);
    CostingsLink.Name := 'CostingsLink';
    CostingsLink.Left := 40;
    CostingsLink.Top := 240;
    CostingsLink.Width := 54;
    CostingsLink.Height := 18;
    CostingsLink.Caption := 'Costings';
    CostingsLink.ElementFont := efCSS;
    CostingsLink.ElementPosition := epIgnore;
    CostingsLink.HeightStyle := ssAuto;
    CostingsLink.HeightPercent := 100.000000000000000000;
    CostingsLink.WidthStyle := ssAuto;
    CostingsLink.WidthPercent := 100.000000000000000000;
    SetEvent(CostingsLink, Self, 'OnClick', 'CostingsLinkClick');
    InvoicesLink.SetParentComponent(Self);
    InvoicesLink.Name := 'InvoicesLink';
    InvoicesLink.Left := 40;
    InvoicesLink.Top := 264;
    InvoicesLink.Width := 54;
    InvoicesLink.Height := 18;
    InvoicesLink.Caption := 'Invoices';
    InvoicesLink.ElementFont := efCSS;
    InvoicesLink.HeightStyle := ssAuto;
    InvoicesLink.HeightPercent := 100.000000000000000000;
    InvoicesLink.WidthPercent := 100.000000000000000000;
    SetEvent(InvoicesLink, Self, 'OnClick', 'InvoicesLinkClick');
    ActionsLink.SetParentComponent(Self);
    ActionsLink.Name := 'ActionsLink';
    ActionsLink.Left := 40;
    ActionsLink.Top := 296;
    ActionsLink.Width := 46;
    ActionsLink.Height := 18;
    ActionsLink.Caption := 'Actions';
    ActionsLink.ElementFont := efCSS;
    ActionsLink.HeightStyle := ssAuto;
    ActionsLink.HeightPercent := 100.000000000000000000;
    ActionsLink.WidthPercent := 100.000000000000000000;
    SetEvent(ActionsLink, Self, 'OnClick', 'ActionsLinkClick');
    UserNameLabel.SetParentComponent(Self);
    UserNameLabel.Name := 'UserNameLabel';
    UserNameLabel.Left := 400;
    UserNameLabel.Top := 16;
    UserNameLabel.Width := 67;
    UserNameLabel.Height := 18;
    UserNameLabel.Caption := 'Username';
    UserNameLabel.ElementFont := efCSS;
    UserNameLabel.ElementPosition := epIgnore;
    UserNameLabel.HeightStyle := ssAuto;
    UserNameLabel.HeightPercent := 100.000000000000000000;
    UserNameLabel.WidthStyle := ssAuto;
    UserNameLabel.WidthPercent := 100.000000000000000000;
    UserScopeLabel.SetParentComponent(Self);
    UserScopeLabel.Name := 'UserScopeLabel';
    UserScopeLabel.Left := 400;
    UserScopeLabel.Top := 48;
    UserScopeLabel.Width := 69;
    UserScopeLabel.Height := 18;
    UserScopeLabel.Caption := 'UserScope';
    UserScopeLabel.ElementFont := efCSS;
    UserScopeLabel.HeightStyle := ssAuto;
    UserScopeLabel.HeightPercent := 100.000000000000000000;
    UserScopeLabel.WidthPercent := 100.000000000000000000;
    EventViewerLink.SetParentComponent(Self);
    EventViewerLink.Name := 'EventViewerLink';
    EventViewerLink.Left := 168;
    EventViewerLink.Top := 168;
    EventViewerLink.Width := 84;
    EventViewerLink.Height := 18;
    EventViewerLink.Caption := 'Event Viewer';
    EventViewerLink.ElementFont := efCSS;
    EventViewerLink.ElementPosition := epIgnore;
    EventViewerLink.HeightStyle := ssAuto;
    EventViewerLink.HeightPercent := 100.000000000000000000;
    EventViewerLink.WidthStyle := ssAuto;
    EventViewerLink.WidthPercent := 100.000000000000000000;
    SetEvent(EventViewerLink, Self, 'OnClick', 'EventViewerLinkClick');
    RemittancesLink.SetParentComponent(Self);
    RemittancesLink.Name := 'RemittancesLink';
    RemittancesLink.Left := 168;
    RemittancesLink.Top := 192;
    RemittancesLink.Width := 80;
    RemittancesLink.Height := 18;
    RemittancesLink.Caption := 'Remittances';
    RemittancesLink.ElementFont := efCSS;
    RemittancesLink.HeightStyle := ssAuto;
    RemittancesLink.HeightPercent := 100.000000000000000000;
    RemittancesLink.WidthPercent := 100.000000000000000000;
    SetEvent(RemittancesLink, Self, 'OnClick', 'RemittancesLinkClick');
    AppVersionLabel.SetParentComponent(Self);
    AppVersionLabel.Name := 'AppVersionLabel';
    AppVersionLabel.Left := 360;
    AppVersionLabel.Top := 304;
    AppVersionLabel.Width := 47;
    AppVersionLabel.Height := 18;
    AppVersionLabel.Caption := 'Version';
    AppVersionLabel.ElementFont := efCSS;
    AppVersionLabel.HeightStyle := ssAuto;
    AppVersionLabel.HeightPercent := 100.000000000000000000;
    AppVersionLabel.WidthPercent := 100.000000000000000000;
    CommunicationsLink.SetParentComponent(Self);
    CommunicationsLink.Name := 'CommunicationsLink';
    CommunicationsLink.Left := 168;
    CommunicationsLink.Top := 216;
    CommunicationsLink.Width := 106;
    CommunicationsLink.Height := 18;
    CommunicationsLink.Caption := 'Communications';
    CommunicationsLink.ElementFont := efCSS;
    CommunicationsLink.HeightStyle := ssAuto;
    CommunicationsLink.HeightPercent := 100.000000000000000000;
    CommunicationsLink.WidthPercent := 100.000000000000000000;
    SetEvent(CommunicationsLink, Self, 'OnClick', 'CommunicationsLinkClick');
    LogoutLink.SetParentComponent(Self);
    LogoutLink.Name := 'LogoutLink';
    LogoutLink.Left := 168;
    LogoutLink.Top := 16;
    LogoutLink.Width := 44;
    LogoutLink.Height := 18;
    LogoutLink.Caption := 'Logout';
    LogoutLink.ElementFont := efCSS;
    LogoutLink.HeightStyle := ssAuto;
    LogoutLink.HeightPercent := 100.000000000000000000;
    LogoutLink.WidthPercent := 100.000000000000000000;
    SetEvent(LogoutLink, Self, 'OnClick', 'LogoutLinkClick');
    MainToast.Position := tpBottomRight;
  finally
    SchoolsLink.AfterLoadDFMValues;
    AcademiesLink.AfterLoadDFMValues;
    DashboardLink.AfterLoadDFMValues;
    CostingsLink.AfterLoadDFMValues;
    InvoicesLink.AfterLoadDFMValues;
    ActionsLink.AfterLoadDFMValues;
    UserNameLabel.AfterLoadDFMValues;
    UserScopeLabel.AfterLoadDFMValues;
    EventViewerLink.AfterLoadDFMValues;
    RemittancesLink.AfterLoadDFMValues;
    AppVersionLabel.AfterLoadDFMValues;
    CommunicationsLink.AfterLoadDFMValues;
    LogoutLink.AfterLoadDFMValues;
    MainToast.AfterLoadDFMValues;
  end;
end;

End.
